'use strict';

var after = require('./siblings').after;

module.exports = first;

/* Get the first child in `parent`. */
function first(parent, includeWhiteSpace) {
  return after(parent, -1, includeWhiteSpace);
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-html/lib/omission/util/first.js
// module id = 986
// module chunks = 0